import { AddOnPricingVariant } from '@larki/shared/type/pricing';

import text from '../../../text';

// Add-on category names are bim_* / twod_plan_*; each variant row is described
// relative to its paired add-on (BIM <-> 2D Feature Plan).
export const addOnVariantLabel = (
  categoryName: string | undefined,
  variant: AddOnPricingVariant
) => {
  if (!categoryName) return variant;
  const [self, other] = categoryName.startsWith('bim')
    ? [text('bim'), text('featurePlan2D')]
    : [text('featurePlan2D'), text('bim')];
  return variant === 'single'
    ? text('addOnOnly', { addOn: self })
    : text('addOnWith', { addOn: self, other });
};

export const formatMultiplier = (value: number) => `${value} x`;
